import {
  MDSSessionState,
  MDSSessionActionTypes,
  MDSSessionAction,
} from "../../mds-session-context.types";

export const mdsCurrentSessionReducer = (
  state: MDSSessionState,
  action: MDSSessionActionTypes
): MDSSessionState => {
  switch (action.type) {
    case MDSSessionAction.SetCurrentSessionId: {
      const newSessionId = action.payload;

      // Filter out events that don't match the new session ID
      const filteredSessionEvents = state.events.sessionEvents.filter(
        event => event.session_id === newSessionId
      );

      return {
        ...state,
        currentSessionId: newSessionId,
        events: {
          ...state.events,
          sessionEvents: filteredSessionEvents,
        },
      };
    }

    default:
      return state;
  }
};
